import * as React from "react";
import { createPortal } from "react-dom";
import { ClickOutsideWatcher, FAButton } from "./BasicElements";
const modalRoot = document.getElementById("root");
export class BackgroundModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this._modalRootChild = document.createElement("div");
        this._modalRootChild.className = "fullScreen modal";
    }
    componentDidMount() {
        modalRoot.appendChild(this._modalRootChild);
    }
    componentWillUnmount() {
        this._modalRootChild.className += " hide";
        setTimeout(() => { modalRoot.removeChild(this._modalRootChild); }, 500);
    }
    render() {
        if (this.props.outsideClick) {
            return createPortal(React.createElement(ClickOutsideWatcher, { callback: this.props.outsideClick }, this.props.children), this._modalRootChild);
        }
        else {
            return createPortal(this.props.children, this._modalRootChild);
        }
    }
}
function LoadingSpinner(props) {
    return React.createElement("div", { className: "loadDetails" },
        React.createElement("p", { className: "loadTitle" }, props.title),
        React.createElement("div", { className: "sequencerSpinner" },
            React.createElement("span", null, "\uD834\uDD5D"),
            React.createElement("span", null, "\uD834\uDD5E"),
            React.createElement("span", null, "\uD834\uDD5F"),
            React.createElement("span", null, "\uD834\uDD60")));
}
export function LoadingSpinnerModal(props) {
    return React.createElement(BackgroundModal, null,
        React.createElement(LoadingSpinner, Object.assign({}, props)));
}
function ErrorBox(props) {
    return React.createElement("div", null,
        React.createElement(FAButton, { className: "errorModalClose buttonAnim", iconName: "fa fa-close", onClick: props.onClose }),
        React.createElement("div", { className: "errorModal" },
            React.createElement("div", { className: "errorModalTitle" },
                React.createElement("i", { className: "fa fa-exclamation-circle" })),
            React.createElement("p", { className: "errorModalContent" }, props.error)));
}
export class ErrorModal extends React.Component {
    render() {
        return React.createElement(BackgroundModal, null,
            React.createElement(ErrorBox, Object.assign({}, this.props)));
    }
}
export class LoadingErrorModal extends React.Component {
    render() {
        return React.createElement(BackgroundModal, { outsideClick: (!this.props.loading ? this.props.onClose : undefined) }, this.props.loading ? React.createElement(LoadingSpinner, { title: this.props.title }) : React.createElement(ErrorBox, { error: this.props.title, onClose: this.props.onClose }));
    }
}
//# sourceMappingURL=Modal.js.map